export async function api<T>(path: string, options: RequestInit = {}) {
  const response = await fetch(path, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...(options.headers ?? {})
    }
  });
  const text = await response.text();
  let payload: { success?: boolean; ok?: boolean; data?: T; error?: string };
  try {
    payload = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(`API returned non-JSON response (${response.status})`);
  }
  if (!response.ok || !payload.ok) throw new Error(payload.error ?? "API error");
  return payload.data as T;
}

export function adminHeaders() {
  const token = localStorage.getItem("admin_token") ?? localStorage.getItem("adminToken") ?? "";
  return { authorization: `Bearer ${token}` };
}
